var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71216 12C8.71216 10.1452 10.1846 8.63966 11.9987 8.63966C13.8127 8.63966 15.2852 10.1452 15.2852 12C15.2852 13.8547 13.8127 15.3603 11.9987 15.3603C10.1846 15.3603 8.71216 13.8547 8.71216 12ZM9.85068 12C9.85068 13.2106 10.8146 14.1962 11.9987 14.1962C13.1827 14.1962 14.1467 13.2106 14.1467 12C14.1467 10.7893 13.1827 9.80374 11.9987 9.80374C10.8146 9.80374 9.85068 10.7893 9.85068 12Z",
    fill: "#4A7AF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59853 14.3282C3.79398 13.0477 3.79398 10.9601 4.59853 9.67184C6.45812 6.70732 9.15261 5 11.9989 5C14.8452 5 17.5397 6.70732 19.3917 9.67184C20.1963 10.9523 20.1963 13.0399 19.3917 14.3282C17.5397 17.2927 14.8452 19 11.9989 19C9.14502 19 6.45053 17.2927 4.59853 14.3282ZM5.56248 10.3004C4.99322 11.2084 4.99322 12.7916 5.56248 13.6996C7.20195 16.3304 9.5473 17.8359 11.9989 17.8359C14.4505 17.8359 16.7959 16.3304 18.4353 13.6996C19.0046 12.7916 19.0046 11.2084 18.4353 10.3004C16.7959 7.66962 14.4505 6.16408 11.9989 6.16408C9.5473 6.16408 7.20195 7.66962 5.56248 10.3004Z",
    fill: "#4A7AF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d8566cbe5a4ed6b16a74061b6c1ee143.svg";
export { ForwardRef as ReactComponent };